module.exports = __webpack_public_path__ + "img/colorFull.ba138f53.svg";